export const SAVE_USER = 'add_user';
export const LOAD_USER_LIST = 'load_user_list';
export const LOAD_USER = 'load_user';
export const DESTROY_USER = 'destroy_user';
export const IS_LOADING = 'loading_user';
export const USER_LIST_NEED_RELOAD = 'user_list_need_reload';
export const USER_CHANGE_PASS = 'user_change_pass';
export const FORM_ERROR = 'user_form_error';



// WEBPACK FOOTER //
// ./src/redux/actions/types/userTypes.js